import { render, staticRenderFns } from "./LinksList.vue?vue&type=template&id=618090c1&scoped=true"
import script from "./LinksList.vue?vue&type=script&lang=js"
export * from "./LinksList.vue?vue&type=script&lang=js"
import style0 from "./LinksList.vue?vue&type=style&index=0&id=618090c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618090c1",
  null
  
)

export default component.exports